// import css from "./product.module.css";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import { db } from "../../firebase";

// export default function Hero({ oneProd }) {
//   const navigate = useNavigate();

//   /*
//    * undefined — ще триває перевірка;
//    * null — героя немає або він прихований;
//    * object — героя знайдено.
//    */
//   const [heroData, setHeroData] = useState(undefined);

//   const hasRealText = (value) => {
//     if (value === null || value === undefined) return false;

//     return (
//       String(value)
//         .replace(/\u00A0/g, " ")
//         .trim().length > 0
//     );
//   };

//   const heroPhoto = oneProd?.heroFoto;
//   const heroTitle = oneProd?.heroLabelText;
//   const heroDescription = oneProd?.heroParagrafText;
//   const heroName = oneProd?.bookHero;

//   const hasHeroProductData =
//     hasRealText(heroPhoto) &&
//     hasRealText(heroTitle) &&
//     hasRealText(heroDescription) &&
//     hasRealText(heroName);

//   useEffect(() => {
//     let isActive = true;

//     const fetchHeroData = async () => {
//       // Починаємо нову перевірку героя
//       setHeroData(undefined);

//       if (!hasHeroProductData) {
//         setHeroData(null);
//         return;
//       }

//       try {
//         const heroQuery = query(
//           collection(db, "hero"),
//           where("name", "==", String(heroName).trim()),
//         );

//         const querySnapshot = await getDocs(heroQuery);

//         if (!isActive) return;

//         // Якщо героя з таким name немає — приховуємо весь блок
//         if (querySnapshot.empty) {
//           setHeroData(null);
//           return;
//         }

//         const firstHeroDoc = querySnapshot.docs[0];

//         const foundHero = {
//           id: firstHeroDoc.id,
//           ...firstHeroDoc.data(),
//         };

//         // Якщо герой прихований — також приховуємо весь блок
//         if (foundHero.showOnSite === false) {
//           setHeroData(null);
//           return;
//         }

//         // Без uid перейти на сторінку героя неможливо,
//         // тому такий блок також не показуємо
//         if (!hasRealText(foundHero.uid)) {
//           setHeroData(null);
//           return;
//         }

//         setHeroData(foundHero);
//       } catch (error) {
//         console.error("Помилка при отриманні героя:", error);

//         if (isActive) {
//           setHeroData(null);
//         }
//       }
//     };

//     fetchHeroData();

//     return () => {
//       isActive = false;
//     };
//   }, [heroName, heroPhoto, heroTitle, heroDescription, hasHeroProductData]);

//   const goToHeroPage = () => {
//     if (!heroData?.uid) return;

//     navigate(`/hero/${heroData.uid}`);
//   };

//   /*
//    * Не показуємо блок, коли:
//    * 1. товар ще не завантажився;
//    * 2. поля героя в товарі не заповнені;
//    * 3. триває перевірка Firestore;
//    * 4. героя немає;
//    * 5. герой прихований;
//    * 6. у героя немає uid.
//    */
//   if (!oneProd || !hasHeroProductData || !heroData?.uid) {
//     return null;
//   }

//   return (
//     <div className={css.heroWrapp}>
//       <div className={css.heroPicRo}>
//         <div className={css.heroPicRoteta}>
//           <img
//             src={String(heroPhoto).trim()}
//             className={css.theSameHeroPic}
//             alt={String(heroTitle).trim()}
//           />
//         </div>
//       </div>

//       <div className={css.wrapHeroText}>
//         <h1 className={css.wrapHeroTextH1}>{String(heroTitle).trim()}</h1>

//         <p className={css.wrapHeroTextP}>{String(heroDescription).trim()}</p>

//         <button type="button" onClick={goToHeroPage} className={css.heroButton}>
//           Сторінка героя
//         </button>
//       </div>
//     </div>
//   );
// }
import css from "./product.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export default function Hero({ oneProd }) {
  const navigate = useNavigate();

  /*
   * undefined — ще триває перевірка;
   * null — героя немає або він прихований;
   * object — героя знайдено.
   */
  const [heroData, setHeroData] = useState(undefined);

  const hasRealText = (value) => {
    if (value === null || value === undefined) return false;

    return (
      String(value)
        .replace(/\u00A0/g, " ")
        .trim().length > 0
    );
  };

  const heroPhoto = oneProd?.heroFoto;
  const heroTitle = oneProd?.heroLabelText;
  const heroDescription = oneProd?.heroParagrafText;
  const heroName = oneProd?.bookHero;

  const hasHeroProductData =
    hasRealText(heroPhoto) &&
    hasRealText(heroTitle) &&
    hasRealText(heroDescription) &&
    hasRealText(heroName);

  /*
   * ДЕТАЛЬНА ПЕРЕВІРКА ПОЛІВ ТОВАРУ
   */
  useEffect(() => {
    console.group("🦸 HERO DEBUG");

    console.log("📦 oneProd:", oneProd);

    if (!oneProd) {
      console.error("❌ oneProd відсутній");
      console.groupEnd();
      return;
    }

    if (!hasRealText(heroPhoto)) {
      console.error("❌ Відсутнє поле heroFoto:", heroPhoto);
    } else {
      console.log("✅ heroFoto:", heroPhoto);
    }

    if (!hasRealText(heroTitle)) {
      console.error("❌ Відсутнє поле heroLabelText:", heroTitle);
    } else {
      console.log("✅ heroLabelText:", heroTitle);
    }

    if (!hasRealText(heroDescription)) {
      console.error("❌ Відсутнє поле heroParagrafText:", heroDescription);
    } else {
      console.log("✅ heroParagrafText:", heroDescription);
    }

    if (!hasRealText(heroName)) {
      console.error("❌ Відсутнє поле bookHero:", heroName);
    } else {
      console.log("✅ bookHero:", heroName);
    }

    console.log(
      hasHeroProductData
        ? "✅ Усі поля героя в товарі заповнені"
        : "❌ Не всі поля героя в товарі заповнені",
    );

    console.groupEnd();
  }, [
    oneProd,
    heroPhoto,
    heroTitle,
    heroDescription,
    heroName,
    hasHeroProductData,
  ]);

  useEffect(() => {
    let isActive = true;

    const fetchHeroData = async () => {
      setHeroData(undefined);

      console.group("🔥 FIRESTORE HERO CHECK");

      /*
       * 1. Перевірка самого товару
       */
      if (!oneProd) {
        console.error("❌ Товар oneProd ще не завантажений");
        console.groupEnd();

        if (isActive) {
          setHeroData(null);
        }

        return;
      }

      /*
       * 2. Перевірка полів героя в товарі
       */
      if (!hasHeroProductData) {
        console.error(
          "❌ Firestore запит НЕ виконується, тому що відсутні поля героя в товарі",
        );

        console.log({
          heroFoto: heroPhoto,
          heroLabelText: heroTitle,
          heroParagrafText: heroDescription,
          bookHero: heroName,
        });

        console.groupEnd();

        if (isActive) {
          setHeroData(null);
        }

        return;
      }

      try {
        const normalizedHeroName = String(heroName)
          .replace(/\u00A0/g, " ")
          .trim();

        console.log(
          "🔍 Шукаємо героя у Firestore за name:",
          normalizedHeroName,
        );

        const heroQuery = query(
          collection(db, "hero"),
          where("name", "==", normalizedHeroName),
        );

        const querySnapshot = await getDocs(heroQuery);

        if (!isActive) {
          console.warn("⚠️ Компонент вже розмонтований");
          console.groupEnd();
          return;
        }

        console.log("📊 Кількість знайдених героїв:", querySnapshot.size);

        /*
         * 3. Герой не знайдений
         */
        if (querySnapshot.empty) {
          console.error(
            `❌ Героя з name="${normalizedHeroName}" у колекції hero НЕ знайдено`,
          );

          console.error(
            "Перевір точний збіг bookHero товару та name документа героя.",
          );

          setHeroData(null);

          console.groupEnd();
          return;
        }

        /*
         * Виводимо всі знайдені документи
         */
        querySnapshot.docs.forEach((heroDoc, index) => {
          console.log(`📄 HERO DOC ${index + 1}:`, {
            firestoreDocumentId: heroDoc.id,
            ...heroDoc.data(),
          });
        });

        const firstHeroDoc = querySnapshot.docs[0];
        const rawHeroData = firstHeroDoc.data();

        const foundHero = {
          id: firstHeroDoc.id,
          ...rawHeroData,
        };

        console.log("🦸 Знайдений герой:", foundHero);

        /*
         * 4. showOnSite
         */
        if (foundHero.showOnSite === false) {
          console.error("❌ Герой знайдений, але showOnSite === false");

          setHeroData(null);

          console.groupEnd();
          return;
        }

        console.log("✅ showOnSite:", foundHero.showOnSite);

        /*
         * 5. uid
         */
        if (!hasRealText(foundHero.uid)) {
          console.error("❌ Герой знайдений, але в документі відсутній uid");

          console.log("Firestore document ID є:", firstHeroDoc.id);

          console.log("Але поле hero.uid:", foundHero.uid);

          setHeroData(null);

          console.groupEnd();
          return;
        }

        console.log("✅ hero.uid:", foundHero.uid);

        /*
         * Усе добре
         */
        console.log("🎉 ВСІ ПЕРЕВІРКИ ПРОЙДЕНІ — герой повинен відображатись");

        setHeroData(foundHero);

        console.groupEnd();
      } catch (error) {
        console.error("💥 Помилка при отриманні героя з Firestore:", error);

        if (isActive) {
          setHeroData(null);
        }

        console.groupEnd();
      }
    };

    fetchHeroData();

    return () => {
      isActive = false;
    };
  }, [
    oneProd,
    heroName,
    heroPhoto,
    heroTitle,
    heroDescription,
    hasHeroProductData,
  ]);

  const goToHeroPage = () => {
    if (!heroData?.uid) {
      console.error(
        "❌ Неможливо перейти на сторінку героя — відсутній heroData.uid",
        heroData,
      );

      return;
    }

    console.log("➡️ Переходимо на сторінку героя:", `/hero/${heroData.uid}`);

    navigate(`/hero/${heroData.uid}`);
  };

  /*
   * Додатковий лог причини, чому JSX не рендериться
   */
  if (!oneProd) {
    console.warn("🚫 HERO НЕ РЕНДЕРИТЬСЯ: oneProd відсутній");
    return null;
  }

  if (!hasHeroProductData) {
    console.warn("🚫 HERO НЕ РЕНДЕРИТЬСЯ: відсутні обов'язкові поля товару", {
      heroFoto: heroPhoto,
      heroLabelText: heroTitle,
      heroParagrafText: heroDescription,
      bookHero: heroName,
    });

    return null;
  }

  if (heroData === undefined) {
    console.log("⏳ HERO НЕ РЕНДЕРИТЬСЯ: очікуємо відповідь Firestore");

    return null;
  }

  if (heroData === null) {
    console.warn(
      "🚫 HERO НЕ РЕНДЕРИТЬСЯ: герой не пройшов перевірку Firestore",
    );

    return null;
  }

  if (!heroData?.uid) {
    console.warn("🚫 HERO НЕ РЕНДЕРИТЬСЯ: у героя відсутній uid", heroData);

    return null;
  }

  console.log("✅ HERO RENDER:", heroData);

  return (
    <div className={css.heroWrapp}>
      <div className={css.heroPicRo}>
        <div className={css.heroPicRoteta}>
          <img
            src={String(heroPhoto).trim()}
            className={css.theSameHeroPic}
            alt={String(heroTitle).trim()}
          />
        </div>
      </div>

      <div className={css.wrapHeroText}>
        <h1 className={css.wrapHeroTextH1}>{String(heroTitle).trim()}</h1>

        <p className={css.wrapHeroTextP}>{String(heroDescription).trim()}</p>

        <button type="button" onClick={goToHeroPage} className={css.heroButton}>
          Сторінка героя
        </button>
      </div>
    </div>
  );
}
